// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dashboard_wrapper__1BJJ-","content":"dashboard_content__2Gotn","left":"dashboard_left__1bJ07","right":"dashboard_right__grDHB"};